import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ImageViewerComponent } from "./image-viewer/image-viewer.component";
import { CdkDrag } from "@angular/cdk/drag-drop";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { NgbCarouselModule } from "@ng-bootstrap/ng-bootstrap";
import { BastaniPdfViewerComponent } from './bastani-pdf-viewer/bastani-pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FullscreenImageComponent } from "./fullscreen-image/fullscreen-image.component";
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { BastaniLoadingComponent } from './bastani-loading/bastani-loading.component';

@NgModule({
  declarations: [ImageViewerComponent, BastaniPdfViewerComponent, FullscreenImageComponent, DocumentViewerComponent, BastaniLoadingComponent],
  imports: [
    CommonModule,
    CdkDrag,
    MatButtonModule,
    MatIconModule,
    NgbCarouselModule,
    PdfViewerModule
  ],
  exports: [ImageViewerComponent, BastaniPdfViewerComponent, FullscreenImageComponent, DocumentViewerComponent, BastaniLoadingComponent]
})
export class ComponentsModule {}
